import React from 'react';
import TaskList from '../../components/TaskList/TaskList';

const LabelingManagement: React.FC = () => {
  // TODO: move all TaskList codes here
  return <TaskList />;
};
export default LabelingManagement;
